module.exports = __webpack_public_path__ + "static/media/aboutMorphing.51a94784.svg";